import './assets/totalAlertCard.scss';

const TotalAlertCard = ({ alertCount, title, navLink = '' }) => {
  const isLink = Boolean(navLink && navLink !== '' && typeof alertCount === 'number');

  const alertCardClassNames = `total-alert-card p-1 d-flex flex-column justify-content-center align-items-start w-100 bg-primary-shadow h-auto border rounded-2 ${
    isLink ? 'border-primary linked' : 'border-secondary border-opacity-50'
  }`;

  const content = (
    <div className={alertCardClassNames}>
      <div className="total-alert-card__title ms-1">{title}</div>
      <div className="d-flex align-items-center justify-content-between ms-1">
        <div className="d-flex align-items-center">
          <div className="total-alert-card__count">{alertCount}</div>
        </div>
      </div>
    </div>
  );

  return isLink ? (
    <a
      href={navLink}
      rel="noopener noreferrer"
      className="text-decoration-none total-alert-card-link"
      aria-label={title}
    >
      {content}
    </a>
  ) : (
    content
  );
};

export default TotalAlertCard;
